/** Same price table as Crown Crush Buy Bonus: bet × multiplier for tiers 1 / 2 / 3. */
export const BUY_BONUS_TIER_MULTIPLIERS = [4.5, 15, 71.5];

/**
 * Guaranteed-win prices:
 * 1 wild 4.5× → 12×, 2 wild 15× → 25×, 3 wild 71.5× → 71.5×.
 */
export const BUY_BONUS_GUARANTEED_MULTIPLIERS = [12, 25, 71.5];

/**
 * @param {number} bet Base stake sent to the hub (not the purchase price).
 * @param {1 | 2 | 3} type
 * @param {boolean} [guaranteedWins]
 */
export function buyBonusPrice(bet, type, guaranteedWins = false) {
  const table = guaranteedWins ? BUY_BONUS_GUARANTEED_MULTIPLIERS : BUY_BONUS_TIER_MULTIPLIERS;
  const mul = table[type - 1] ?? 0;
  return Number(bet) * mul;
}
